import axios from "axios";
import adminApi from "../axios";
import { v1BaseUrl } from "./apiBaseUrl";

function authConfig(extra = {}) {
  return { ...extra, headers: { ...extra.headers, Authorization: `Bearer ${localStorage.getItem("@token")}` } };
}

function dataOf(response) { return response?.data?.data ?? response?.data ?? []; }

export async function listEnrollments(params = {}) {
  const response = await adminApi.get("course-enrollments", authConfig({ params }));
  return { data: Array.isArray(response?.data?.data) ? response.data.data : [], pagination: response?.data?.pagination };
}

export async function listStudents() {
  const users = dataOf(await adminApi.get("users", authConfig()));
  return Array.isArray(users)
    ? users.filter((user) => String(user.role).toLowerCase() === "student")
    : [];
}

export async function assignCourse({ studentId, courseId, paymentMethod, offlineReference, proofUrl, paymentReceivedAt }) {
  return dataOf(await adminApi.post("course-enrollments", {
    student_id: Number(studentId),
    course_id: Number(courseId),
    payment_method: paymentMethod,
    offline_reference: offlineReference || null,
    proof_url: proofUrl || null,
    payment_received_at: paymentReceivedAt,
  }, authConfig()));
}

export async function getEnrollment(enrollmentId) {
  return dataOf(await adminApi.get(`course-enrollments/${enrollmentId}`, authConfig()));
}

export async function updateDefaultGuru(enrollmentId, guruId) {
  return dataOf(await adminApi.patch(`course-enrollments/${enrollmentId}/default-guru`, { new_guru_id: Number(guruId) }, authConfig()));
}

export async function extendValidity(enrollmentId, validUntil, reason) {
  return dataOf(await adminApi.patch(`course-enrollments/${enrollmentId}/validity`, { valid_until: validUntil, reason }, authConfig()));
}

export async function adjustCredits(enrollmentId, delta, reason) {
  return dataOf(await adminApi.patch(`course-enrollments/${enrollmentId}/session-credits`, { delta: Number(delta), reason }, authConfig()));
}

export async function getAdjustmentHistory(enrollmentId) {
  return dataOf(await adminApi.get(`course-enrollments/${enrollmentId}/adjustments`, authConfig()));
}

const v1Api = axios.create({ baseURL: v1BaseUrl });
v1Api.interceptors.request.use((config) => ({ ...config, ...authConfig() }));

export async function bookEnrollmentClass(payload) {
  return dataOf(await v1Api.post("classes/book", payload, authConfig()));
}

export async function getAvailableBookingSlots(guruId, from, to) {
  const response = await v1Api.get(`classes/availability/${guruId}`, {
    ...authConfig(), params: { from, to },
  });
  if (response.status === 204) return [];
  const rules = Array.isArray(response.data?.data) ? response.data.data : response.data || [];
  return rules.flatMap((rule) => (rule.rrule_all || []).map((slot) => ({
    rule_id: rule.rule_id,
    start: slot.start,
    end: slot.end,
  })));
}
